import { render, staticRenderFns } from "./opinion-data.vue?vue&type=template&id=1346da09"
import script from "./opinion-data.vue?vue&type=script&lang=js"
export * from "./opinion-data.vue?vue&type=script&lang=js"
import style0 from "./opinion-data.vue?vue&type=style&index=0&id=1346da09&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports